import { useEffect } from 'react';

const useHotKey = (callbackFunction: (event: any) => void) => {
  useEffect(() => {
    document.addEventListener('keydown', callbackFunction, false);
    return () => {
      document.removeEventListener('keydown', callbackFunction, false);
    };
  }, [callbackFunction]);
};

export default useHotKey;
